import { render, staticRenderFns } from "./FixedPointsMap.vue?vue&type=template&id=6a3c94ff&scoped=true"
import script from "./FixedPointsMap.vue?vue&type=script&lang=js"
export * from "./FixedPointsMap.vue?vue&type=script&lang=js"
import style0 from "./FixedPointsMap.vue?vue&type=style&index=0&id=6a3c94ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c94ff",
  null
  
)

export default component.exports